import { api } from './client'
import type { Message } from '../types'

export const messagesApi = {
  getHistory: (
    chatId: string,
    cursor?: string,
    limit = 30,
  ): Promise<{ messages: Message[]; next_cursor: string }> =>
    api.get(
      `/v1/messaging/chats/${chatId}/messages?limit=${limit}${cursor ? `&before=${cursor}` : ''}`,
    ),

  getHistoryAfter: (
    chatId: string,
    after: string,
  ): Promise<{ messages: Message[] }> =>
    api.get(
      `/v1/messaging/chats/${chatId}/messages?after=${encodeURIComponent(after)}`,
    ),

  send: (
    chatId: string,
    data: { text: string; media_ids?: string[]; reply_to_message_id?: string; ttl_seconds?: number; silent?: boolean },
  ): Promise<Message> => api.post(`/v1/messaging/chats/${chatId}/messages`, data),

  edit: (chatId: string, messageId: string, text: string): Promise<Message> =>
    api.patch(`/v1/messaging/chats/${chatId}/messages/${messageId}`, { text }),

  delete: (chatId: string, messageId: string, forEveryone = false) =>
    api.delete(
      `/v1/messaging/chats/${chatId}/messages/${messageId}?for_everyone=${forEveryone}`,
    ),

  forward: (chatId: string, messageIds: string[], toChatId: string) =>
    api.post(`/v1/messaging/chats/${chatId}/messages/forward`, {
      message_ids: messageIds,
      to_chat_id: toChatId,
    }),

  react: (chatId: string, messageId: string, emoji: string): Promise<void> =>
    api.post(`/v1/messaging/chats/${chatId}/messages/${messageId}/react`, { emoji }),

  unreact: (chatId: string, messageId: string, emoji: string): Promise<void> =>
    api.delete(`/v1/messaging/chats/${chatId}/messages/${messageId}/react`, { emoji }),
}
